import { styled } from '@mui/material';

export const IframeStyled = styled('iframe')`
  min-height: 350px;
`;
